import {useNavigate} from 'react-router-dom';

const TypeAdsHelp = ({app}: ITypeAdsHelpProps) => {
  const navigate = useNavigate();
  return (
    <div
      className=" rounded-lg text-center border border-blue-1 py-3 flex mt-8 justify-center mx-8"
      onClick={() => navigate(`/${app}/guide-to-add-product`)}
    >
      <span className="icon-information text-blue-1 ml-2 mt-1"></span>
      <p className=" text-blue-1">راهنمای انتخاب نوع آگهی</p>
    </div>
  );
};

export default TypeAdsHelp;
